import axios from "axios";

const api = axios.create({
  baseURL: 'https://api.ingroove.co.za/api',// process.env.REACT_APP_INGROOVE_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ingroove_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
